// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import vgmeetEntity from './entities/vgmeet.json';
import vgmeetMenu from '../pages/vgmeet/menu.json';
import vgmeetFullForm from '../pages/vgmeet/forms/full.json';
import vgmeetContextForm from '../pages/vgmeet/forms/context.json';
import vgmeetMiniForm from '../pages/vgmeet/forms/mini.json';
import vgmeetLookupForm from '../pages/vgmeet/forms/lookup.json';
import vgmeetTableView from '../pages/vgmeet/views/table.json';
import vgmeetStagesView from '../pages/vgmeet/views/stages.json';
import vgmeetCardsView from '../pages/vgmeet/views/cards.json';
import vgmeetInlineView from '../pages/vgmeet/views/inline.json';
import vgmeetBacklogView from '../pages/vgmeet/views/backlog.json';
import vgmeetSplitView from '../pages/vgmeet/views/split.json';
import vgmeetCalendarView from '../pages/vgmeet/views/calendar.json';
import vgmeetDashboardView from '../pages/vgmeet/views/dashboard.json';

/** Тип запису «Зустріч із групою» зі сторінками пакета: меню, форми та подання з pages/vgmeet/. */
export const vgmeetDefinition: IRecordTypeDefinition = {
  ...vgmeetEntity,
  views: assembleViewSet({
      table: vgmeetTableView,
      stages: vgmeetStagesView,
      cards: vgmeetCardsView,
      inline: vgmeetInlineView,
      backlog: vgmeetBacklogView,
      split: vgmeetSplitView,
      calendar: vgmeetCalendarView,
      dashboard: vgmeetDashboardView,
  }),
  form: vgmeetFullForm,
  forms: { full: vgmeetFullForm, context: vgmeetContextForm, mini: vgmeetMiniForm, lookup: vgmeetLookupForm },
  menu: vgmeetMenu,
} as IRecordTypeDefinition;
